import { TenantInfo, CreateTenantForm } from '@/features/auth';
import { axios } from '@/lib/axios';

export const APIcreateTenant = (data: CreateTenantForm): Promise<TenantInfo> => {
    return axios.post('/tenant', { data });
};
